/* lua.js generated code 0.3.0 */

require("hecore/utils")
require("hecore/EventDispatcher")

// require("hecore/box2d/b2BodyDef")
// require("hecore/box2d/b2FixtureDef")

// TODO: restore
// require("hecore/ResourceLoader")

// require("hecore/luaJavaConvert")
require("hecore/ui/PopoutManager")
// require("hecore/box2d/b2Init")

cc.log("==== hecore imported =======")
